import React from "react";
import Plot from "react-plotly.js";
import { useEffect } from "react";

const TypesPie = ({ isEmbed = false }) => {
  const values = [28, 446, 61, 24, 52, 117];
  const labels = ["Other", "PWR", "PHWR", "LWHR", "GCR", "BWR"];
  useEffect(() => {
    if (!isEmbed) return;

    const originalMargin = document.body.style.margin;
    const originalPadding = document.body.style.padding;

    document.body.style.margin = "0";
    document.body.style.padding = "0";

    return () => {
      document.body.style.margin = originalMargin;
      document.body.style.padding = originalPadding;
    };
  }, [isEmbed]);

  return (
    <div className="w-full flex justify-center">
      <Plot
        data={[
          {
            type: "pie",
            values: values,
            labels: labels,
            textinfo: "label+percent",
            insidetextorientation: "radial",
            hole: 0.3,
            hovertemplate: "%{label}: %{value} Reactors<br>(%{percent})<extra></extra>",
          },
        ]}
        layout={{
          title: "Reactor Types Distribution",
          autosize: true,
          margin: { t: 50, b: 50, l: 50, r: 50 },
        }}
        useResizeHandler={true}
        style={{ width: "100%", height: "100%" }}
        config={{ displayModeBar: false, scrollZoom: false }}
      />
    </div>
  );
};

export default TypesPie;
